module.exports = __webpack_public_path__ + "img/icon-cross-straight.ca2202bf.svg";